import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { PeopleService } from 'app/profile/services/people.service';
import { TabComponent } from '../tab-component';
import { ActivatedRoute } from '@angular/router';
import { SearchResult, GeneralSettings } from 'app/profile/models/generic.model';
import { Contact, JobRole, ExternalPartner, ValidationTask } from 'app/profile/models/people.model';
import { PageEvent, TslDialog } from '@tesla/ng-tds';
import { BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { JobtitleFormDialogComponent } from './jobtitle-form-dialog/jobtitle-form-dialog.component';
import { ExternalFormDialogComponent } from './external-form-dialog/external-form-dialog.component';
import { Store, select } from '@ngrx/store';
import { GetSupplierProfileCurrentUser, ClearSupplierDetailsByCode, GetCountryList, GetValidationTaskByCode,GetPreventativeInProgress, GetSupplierContactListByCode, GetEmailDomains } from 'app/profile/store/app.actions';
import { SelectCurrentUser, getGeneralSettings, getAvailableConfiguration, SelectValidationTask,SelectPreventativeInProgress, SelectSupplierContactList, SelectEmailDomainList } from 'app/profile/store/app.selector';
import { UserDetails } from 'app/profile/models/user.model';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { ManageContactComponent } from './contacts/manage-contact/manage-contact.component';
import { I18nService } from 'app/shared/services/i18n.service';
import { AppSettings } from '../../../app.settings';
import { isDataUnderReview } from 'app/shared/constants';

@Component({
    selector: 'app-people',
    templateUrl: './people.component.html',
    styleUrls: ['./people.component.scss']
})
export class PeopleComponent implements OnInit, TabComponent {
    settings: GeneralSettings;
    @Input() data: any;
    supplierCode: string;
    defaultTabIndex = 0;
    deleteTitle: string;
    deleteConfirmation: string;
    wsmUrl: string;

    preventativeHold: boolean =false;
    // contact table
    contactsResult: SearchResult<Contact> = new SearchResult<Contact>();
    currentContactsPage: BehaviorSubject<Array<Contact>> = new BehaviorSubject([]);
    contactsColumns: Array<string> = ['name', 'category', 'jobtitle', 'email', 'mobile', 'phone', 'linked', 'primary', 'portalaccount'];
    contactPageSize = 10;

    // jobs table
    jobsResult: JobRole[] = [];
    currentJobsPage: BehaviorSubject<Array<JobRole>> = new BehaviorSubject([]);
    jobsColumns: Array<string> = ['jobtitle', 'department', 'action'];
    jobPageSize = 10;

    // externals table
    externalsResult: ExternalPartner[] = [];
    currentExternalsPage: BehaviorSubject<Array<ExternalPartner>> = new BehaviorSubject([]);
    externalsColumns: Array<string> = ['company', 'country', 'servicetype', 'jobtitle', 'department', 'acreditations', 'action'];
    externalPageSize = 10;

    pageSizeOptions: number[] = [10, 25, 50, 100, 250];
    userDetails: UserDetails = new UserDetails();
    isPrimary: boolean;
    isProfileAdmin: boolean;
    @ViewChild('manageContact', { static: false }) manageContact: ManageContactComponent;
    availableFields: string[];

    validationTask: ValidationTask;
    helpUrl: string;
    contactPurposeHelpUrl: string;
    showCMTUrl: boolean = false;
    cmtUrl: string;

    // Data Review Variables
    isDataUnderReview: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private config: AppSettings,
        private service: PeopleService,
        private dialog: TslDialog,
        public matDialog: MatDialog,
        public translate: I18nService,
        private store: Store<SupplierState>) {

    }

    public isDirty() {
        return this.manageContact ? !this.manageContact.canDeactivate() : false;
    }

    ngOnInit() {
        this.store.select(getGeneralSettings).subscribe(res => {
            if (res) {
                this.settings = res;
                this.showCMTUrl = this.settings.settings.showCMTLink === "1";
                this.cmtUrl = this.settings.settings.cmtUrl;
                this.helpUrl = this.settings.settings.contactsHelpUrl;
                this.contactPurposeHelpUrl = this.settings.settings.contactPurposeHelpUrl;
            }
        });

        this.route.params.subscribe(params => {
            // navigate to internal tab
            if (params["internal"]) {
                this.setInternalTab(params["internal"].toLowerCase());
            }
        });
        this.route.parent.params.subscribe(params => {
            if (!params["code"]) {
                return;
            }

            this.supplierCode = params["code"];
            this.store.dispatch(new ClearSupplierDetailsByCode());
            this.store.dispatch(new GetSupplierProfileCurrentUser());

            this.store.pipe(select(SelectCurrentUser)).subscribe(result => {
                if (result) {
                    this.userDetails = result;
                    if (this.userDetails.supplierContact && this.userDetails.supplierContact.supplierMaps) {
                        const supplierMap = this.userDetails.supplierContact.supplierMaps.find(x => x.supplierCode === this.supplierCode);
                        this.isPrimary = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "primary");
                        this.isProfileAdmin = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "profile admin");
                        this.store.dispatch(new GetValidationTaskByCode(this.supplierCode));
                    }
                }
            });

            this.store.select((getAvailableConfiguration)).subscribe((result: string[]) => {
                this.availableFields = result;
            });
            this.wsmUrl = `${this.config}edit/${this.supplierCode}/contact`;
            this.loadResources();

            // Get Data
            this.store.dispatch(new GetSupplierContactListByCode(this.supplierCode));
            this.store.dispatch(new GetEmailDomains(this.supplierCode, false));
            this.store.select(SelectSupplierContactList).subscribe(dataList => {
                this.isDataUnderReview = isDataUnderReview(dataList);
                if(this.isDataUnderReview == false)
                {
                    this.store.select(SelectEmailDomainList).subscribe(domainDataList =>
                    {
                        this.isDataUnderReview = isDataUnderReview(domainDataList);
                    })         
                }
            });
        });

        this.store.dispatch(new GetPreventativeInProgress(this.supplierCode,true));
      this.store.pipe(select(SelectPreventativeInProgress)).subscribe(x => {
        if (x) {
          this.preventativeHold = x;
        }
      });
    }

    checkUserRole(role: string): boolean {
        if (this.userDetails && this.userDetails.supplierContact && this.supplierCode) {
            // this.userDetails.supplierContact.supplierMaps.find(x=>x.supplierCode === this.supplierCode)
        }
        return false;
    }

    onContactsPageChange(pageChange: PageEvent) {
        const { previousPageIndex, pageSize, pageIndex } = pageChange;

        if (previousPageIndex === pageIndex) {
            this.currentContactsPage.next([...this.contactsResult.items].slice(0, pageSize));
        } else {
            const from = pageIndex * pageSize;
            const to = from + pageSize;
            this.currentContactsPage.next([...this.contactsResult.items].slice(from, to));
        }
    }

    onJobsPageChange(pageChange: PageEvent) {
        const { previousPageIndex, pageSize, pageIndex } = pageChange;

        if (previousPageIndex === pageIndex) {
            this.currentJobsPage.next([...this.jobsResult].slice(0, pageSize));
        } else {
            const from = pageIndex * pageSize;
            const to = from + pageSize;
            this.currentJobsPage.next([...this.jobsResult].slice(from, to));
        }
    }

    onExternalsPageChange(pageChange: PageEvent) {
        const { previousPageIndex, pageSize, pageIndex } = pageChange;

        if (previousPageIndex === pageIndex) {
            this.currentExternalsPage.next([...this.externalsResult].slice(0, pageSize));
        } else {
            const from = pageIndex * pageSize;
            const to = from + pageSize;
            this.currentExternalsPage.next([...this.externalsResult].slice(from, to));
        }
    }

    onAddJobRole(): void {
        const jobrole = new JobRole();
        this.openJobRoleDialog(jobrole);
    }

    onEditJobRole(jobRole: JobRole): void {
        this.openJobRoleDialog(jobRole);
    }

    onRemoveJobRole(jobRole: JobRole): void {
        this.dialog.confirm(this.translate.get(this.deleteTitle), this.translate.get(this.deleteConfirmation))
            .afterClosed()
            .subscribe(confirmed => {
                if (confirmed) {
                    this.service.deleteJobRole(this.supplierCode, jobRole.id)
                        .subscribe(_ => {
                            this.loadJobRoles();
                        });
                }
            });
    }

    onAddExternal(): void {
        const external = new ExternalPartner();
        this.openExternalDialog(external);
    }

    onEditExternal(external: ExternalPartner): void {
        this.openExternalDialog(external);
    }

    onRemoveExternal(external: ExternalPartner): void {
        this.dialog.confirm(this.translate.get(this.deleteTitle), this.translate.get(this.deleteConfirmation))
            .afterClosed()
            .subscribe(confirmed => {
                if (confirmed) {
                    this.service.deleteExternalPartner(this.supplierCode, external.id)
                        .subscribe(_ => {
                            this.loadExternalPartners();
                        });
                }
            });
    }

    navigateToValidationTask() {
        event.preventDefault();
        window.open(`${this.config.SRM_UI_URL}tasks?taskTypeName=ContactValidation`);
    }

    private openJobRoleDialog(jobrole: JobRole): void {
        jobrole.supplierCode = this.supplierCode;
        const dialogRef = this.matDialog.open(JobtitleFormDialogComponent, { width: '400px', data: jobrole });

        dialogRef.afterClosed()
            .subscribe(jobRole => {
                if (jobRole === undefined) {
                    return;
                }

                if (jobRole.id === undefined || jobRole.id === 0) {
                    // create
                    this.service.createJobRole(this.supplierCode, jobRole)
                        .subscribe(_ => {
                            this.loadJobRoles();
                        });
                } else {
                    // update
                    this.service.updateJobRole(this.supplierCode, jobrole.id, jobRole)
                        .subscribe(_ => {
                            this.loadJobRoles();
                        });
                }
            });
    }

    private openExternalDialog(external: ExternalPartner): void {
        external.supplierCode = this.supplierCode;
        const dialogRef = this.matDialog.open(ExternalFormDialogComponent, { width: '80%', height: '800px', data: external });

        dialogRef.afterClosed()
            .subscribe(extResp => {
                if (extResp === undefined) {
                    return;
                }

                if (extResp.id === undefined || extResp.id === 0) {
                    // create
                    this.service.createExternalPartner(this.supplierCode, extResp)
                        .subscribe(_ => {
                            this.loadExternalPartners();
                        });
                } else {
                    // update
                    this.service.updateExternalPartner(this.supplierCode, extResp.id, extResp)
                        .subscribe(_ => {
                            this.loadExternalPartners();
                        });
                }
            });
    }

    private loadResources(): void {
        this.translate.getAsync('Delete Item')
            .subscribe(t => this.deleteTitle = t);

        this.translate.getAsync('Are you sure you want to delete this item?')
            .subscribe(t => this.deleteConfirmation = t);

        this.store.dispatch(new GetCountryList());
        this.loadJobRoles();
        this.loadExternalPartners();
        this.store.select((SelectValidationTask)).subscribe((result: ValidationTask) => {
            if (result && result.statusId === 2) {
                this.validationTask = result;
            }
        });

    }

    private loadJobRoles(): void {
        this.service.getJobRoles(this.supplierCode)
            .subscribe(res => {
                this.jobsResult = res;
                if (res !== null) {
                    this.currentJobsPage.next([...this.jobsResult].slice(0, this.jobPageSize));
                }
            });
    }

    private loadExternalPartners(): void {
        this.service.getExternalPartners(this.supplierCode)
            .subscribe(res => {
                this.externalsResult = res;
                if (res !== null) {
                    this.currentExternalsPage.next([...this.externalsResult].slice(0, this.externalPageSize));
                }
            });
    }

    private setInternalTab(internal: string): void {
        switch (internal) {
            case 'jobroles':
                this.defaultTabIndex = 1;
                break;
            case 'external':
                this.defaultTabIndex = 2;
                break;
            default:
                break;
        }
    }
}
